import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Rating from '@material-ui/lab/Rating';

// STYLES
import { Container } from './styles';

const Review = ({ data }) => {
  return (
    <Container className="review">
      {!!data.name && (
        <Typography className="m-b-10" variant="h5">
          {data.name}
        </Typography>
      )}
      {!!data.name && <Rating className="m-b-30" value={data.rating} precision={0.5} readOnly />}
      {!!data.text && <p className="review__text">&quot;{data.text}&quot;</p>}
    </Container>
  );
};

Review.defaultProps = {
  data: PropTypes.object,
};

Review.propTypes = {
  data: PropTypes.object,
};

export default React.memo(Review);
